import React from "react"
import PropTypes from "prop-types"
import { CmsImage } from "@bw/bits"
import { breakpoints } from "../../../theme.js"
import styled, { css } from "styled-components"

const Instagram = ({ posts, numbersOfColumns }) => {
  return (
    <Grid numbersOfColumns={numbersOfColumns}>
      {posts.map((item, i) => (
        <a
          key={i}
          href={item.permalink}
          rel="noreferrer nofollow"
          target="_blank"
        >
          {item.media_type === "VIDEO" ? (
            <VideoWrapper>
              <video>
                <source src={item.media_url} />
              </video>
            </VideoWrapper>
          ) : (
            <CmsImage src={item.media_url} alt="" />
          )}
        </a>
      ))}
    </Grid>
  )
}

const Grid = styled.div`
  display: grid;
  grid-gap: 1px;
  grid-template-columns: repeat(${props => props.numbersOfColumns}, 1fr);

  ${props =>
    props.numbersOfColumns === 6 &&
    css`
      @media (max-width: ${breakpoints.small - 1}px) {
        grid-template-columns: repeat(4, 1fr);
      }
    `}

  img {
    aspect-ratio: 1;
  }
`

const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

Instagram.propTypes = {
  posts: PropTypes.array.isRequired,
  numbersOfColumns: PropTypes.number.isRequired,
}

export { Instagram }
